import { api, ApiError } from "@/api/api";
import { MaskDetails } from "@/api/masks-types";
import { useQuery } from "@tanstack/react-query";

export function useMaskById(id: string | undefined) {
  return useQuery<MaskDetails, ApiError>({
    queryKey: ["GET", "masks", id],
    queryFn: () => api.masks.maskId.get({ maskId: id! }),
    enabled: !!id,
  });
}
